// Keeps the "Freight & Transportation Surcharge" product in the cart.
// The surcharge is a flat fee: the product's own price, added once (quantity 1)
// to orders below the free threshold. Orders at or above the threshold get no surcharge.
(function () {
  const config = window.freightSurcharge;
  if (!config || !config.variantId) return;

  let queue = Promise.resolve();

  function targetQuantity(cart) {
    if (!config.enabled) return 0;

    const merchandise = cart.items
      .filter((item) => item.variant_id !== config.variantId)
      .reduce((sum, item) => sum + item.final_line_price, 0);
    if (merchandise <= 0) return 0;
    if (config.freeAbove > 0 && merchandise >= config.freeAbove) return 0;

    return 1;
  }

  function sectionsToRender() {
    const sections = [];
    const mainCartItems = document.querySelector('cart-items');

    if (mainCartItems && document.getElementById('main-cart-items')) sections.push(...mainCartItems.getSectionsToRender());
    // Re-render the whole drawer, since it may still be in its empty state.
    if (document.getElementById('CartDrawer')) {
      sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' });
    }
    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });

    return sections.filter((s, i) => sections.findIndex((o) => o.section === s.section) === i);
  }

  function renderSections(sections, state) {
    sections.forEach((section) => {
      const container = document.getElementById(section.id);
      const html = state.sections && state.sections[section.section];
      if (!container || !html) return;

      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      const target = container.querySelector(section.selector) || container;
      if (source) target.innerHTML = source.innerHTML;
    });

    const isEmpty = state.item_count === 0;
    ['cart-drawer', 'cart-items', 'cart-drawer-items', '#main-cart-footer'].forEach((selector) => {
      const element = document.querySelector(selector);
      if (element) element.classList.toggle('is-empty', isEmpty);
    });
  }

  function sync() {
    return fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const current = cart.items
          .filter((item) => item.variant_id === config.variantId)
          .reduce((sum, item) => sum + item.quantity, 0);
        const target = targetQuantity(cart);
        if (current === target) return;

        const sections = sectionsToRender();
        const body = JSON.stringify({
          updates: { [config.variantId]: target },
          sections: sections.map((section) => section.section),
          sections_url: window.location.pathname,
        });

        return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) throw new Error(state.description || state.message);
            renderSections(sections, state);
          });
      });
  }

  function requestSync() {
    queue = queue.then(sync).catch((e) => console.error('Freight surcharge:', e));
    return queue;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    requestSync();
  });

  // Make sure the surcharge is correct before leaving for checkout.
  document.addEventListener('submit', (event) => {
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.submitter.setAttribute('disabled', 'disabled');
    requestSync().then(() => {
      window.location.href = '/checkout';
    });
  });

  requestSync();
})();
